export const lineGridVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const lineGridFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform float u_camScale;
uniform vec2 u_size;

out vec4 outColor;

void main() {
  vec2 uv_local = v_texCoord * u_camScale;
  vec2 pixel_local = uv_local * u_size;
  vec2 modulo_local = mod(pixel_local, u_camScale);

  if (modulo_local.x >= 1.0 && modulo_local.y >= 1.0) {
    discard;
  }

  outColor = vec4(0.49, 0.49, 0.49, 1.0);
}
`;
